module.exports = __webpack_public_path__ + "img/zffw1.4701644b.png";